import { de } from "../translations/de/de_translations"
import { en } from "../translations/en/en_translations"
import { sl } from "../translations/sl/sl_translations"

export const translations: { [Key: string]: any } = {
  de,
  en,
  sl,
}
